export default __webpack_public_path__ + "static/media/hero-video-pt.3cf39a05.webm";